// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Colors
 */
/**
 * Paddings, margins.
 */
/**
 *  Images
 */
/**
 * Fonts.
 */
/**
 * Mixins.
 */
.animate {
  -webkit-transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
}
.content__finish-top {
  max-width: 800px;
  margin: auto;
  text-align: center;
}
.content__finish-top .buttons {
  margin: 0 0 40px;
}
.content__finish-top .social {
  margin-bottom: 20px;
}
.content__finish-top a.share {
  padding: 5px 10px;
  color: #ffffff;
}
.content__finish-top a.share:hover {
  cursor: pointer;
}
.content__finish-top a.share.facebook {
  background-color: #3b5999;
}
.content__finish-top a.share.facebook:hover {
  background-color: #344e87;
}
.content__finish-top a.share.twitter {
  background-color: #55acee;
  padding: 5px 7px;
}
.content__finish-top a.share.twitter:hover {
  background-color: #3ea1ec;
}
.content__finish-top a.share.linkedin {
  background-color: #0077b5;
  padding: 5px 7px;
}
.content__finish-top a.share.linkedin:hover {
  background-color: #00669c;
}
.greetings {
  background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/feature/finish/finish.less","webpack://./src/less/variables.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;ACsBF;EACE,4DAAA;EAAA,oDAAA;ADpBF;AAVA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAYF;AAfA;EAMI,gBAAA;AAYJ;AAlBA;EAUI,mBAAA;AAWJ;AArBA;EAcI,iBAAA;EACA,cAAA;AAUJ;AARI;EACE,eAAA;AAUN;AAPI;EACE,yBAAA;AASN;AARM;EACE,yBAAA;AAUR;AANI;EACE,yBAAA;EACA,gBAAA;AAQN;AAPM;EACE,yBAAA;AASR;AALI;EACE,yBAAA;EACA,gBAAA;AAON;AANM;EACE,yBAAA;AAQR;AAFA;EACE,yBAAA;AAIF","sourcesContent":["@import '../../less/variables';\n\n@bg-facebook: rgb(59, 89, 153);\n@bg-twitter: rgb(85, 172, 238);\n@bg-linkedin: rgb(0, 119, 181);\n@bg-darken-pct: 5%;\n\n.content__finish-top {\n  max-width: 800px;\n  margin: auto;\n  text-align: center;\n\n  .buttons {\n    margin: 0 0 40px;\n  }\n\n  .social {\n    margin-bottom: @margin-base * 2;\n  }\n\n  a.share {\n    padding: (@padding-btn / 2) @padding-btn;\n    color: @white;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &.facebook {\n      background-color: @bg-facebook;\n      &:hover {\n        background-color: darken(@bg-facebook, @bg-darken-pct);\n      }\n    }\n\n    &.twitter {\n      background-color: @bg-twitter;\n      padding: (@padding-btn / 2) 7px;\n      &:hover {\n        background-color: darken(@bg-twitter, @bg-darken-pct);\n      }\n    }\n\n    &.linkedin {\n      background-color: @bg-linkedin;\n      padding: (@padding-btn / 2) 7px;\n      &:hover {\n        background-color: darken(@bg-linkedin, @bg-darken-pct);\n      }\n    }\n  }\n}\n\n.greetings {\n  background-color: @white;\n}\n","/**\n * Colors\n */\n@black: rgb(0, 0, 0);\n@blue: rgb(7, 191, 234);\n@cream: rgb(250, 250, 250);\n@gray-dark: rgb(165, 163, 166);\n@gray: rgb(230, 230, 230);\n@gray-outline: rgb(217, 217, 217);\n@green-dark: rgb(63, 136, 41);\n@green: rgb(76, 169, 47);\n@white: rgb(255, 255, 255);\n@error: rgb(255, 0, 0);\n\n/**\n * Paddings, margins.\n */\n@padding-content: 5px;\n@padding-btn: 10px;\n@padding-navi-link: 10px;\n@margin-btn: 10px;\n@margin-base: 10px;\n\n/**\n *  Images\n */\n@img-size-upload: 150px;\n\n/**\n * Fonts.\n */\n@font-size-base: 1.6em;\n\n/**\n * Mixins.\n */\n.animate {\n  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
